import { message } from 'antd';
import * as API from '@/services/api';

export default {
  namespace: 'global',
  state: {
    securityInfo: {},
    api: [],
    key: []
  },
  effects: {
    *getSecurity({ payload }, { call, put }) {
      const res = yield call(API.getSecurity, { ...payload });
      if (res.code === 0) {
        const data = res.data;
        yield put({
          type: 'save',
          payload: {
            securityInfo: data
          },
        });
      }
    },

    *apiKey({ payload }, { call, put }) {
      const res = yield call(API.apiConf, { ...payload });
      if (res.code === 0) {
        const data = res.data;
        yield put({
          type: 'save',
          payload: {
            api: data.api,
            key: data.key
          },
        });
      }
    },

    *sendCode({ payload }, { call }) {
      const res = yield call(API.senCode, payload);
      if (res.code === 0) {
        console.log(res)
      }
    },

    *editSecurity({ payload }, { call }) {
      const res = yield call(API.editSecurity, payload);
      if (res.code === 0) {
        message.success('OK');
      } else {
        message.error('Fail');
      }
    },
  },
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
};
